// extracted by mini-css-extract-plugin
export default {"main":"CustomButton_main__YicJZ"};